import mixpanel from "mixpanel-browser";

// const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN; // dev
const MIXPANEL_TOKEN = "a75726ebc30a72459d2f37e7813de998";

const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn("Mixpanel token not found");
    return;
  }
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: process.env.NODE_ENV !== "production",
    track_pageview: true,
  });
};

const trackEvent = (eventName, properties = {}) => {
  if (!MIXPANEL_TOKEN) return;
  // mixpanel.track(eventName, properties);
  mixpanel.track(eventName, {
    ...properties,
    platform: "web",
  });
};

const identifyUser = (userId, userData = {}) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.identify(userId);
  mixpanel.people.set(userData);
};

export { initMixpanel, trackEvent, identifyUser };
